import { render } from "./Edit.vue?vue&type=template&id=f784e2d2"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/ItemLocations/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f784e2d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f784e2d2', __exports__)) {
    console.log('reload')
    api.reload('f784e2d2', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=f784e2d2", () => {
    console.log('re-render')
    api.rerender('f784e2d2', render)
  })

}


export default __exports__